import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiPopper = ({ misc }: Pick<Tokens, 'misc'>) =>
  ({
    MuiPopper: {
      styleOverrides: {
        root: {
          // @note if it turns out to be that these padding are solely for the SplitButton (read: not generic)
          // move these to the SplitButtonPopper sx
          paddingTop: spacing(0.5),
          paddingBottom: spacing(0.5),
          '> .MuiPaper-root': {
            borderRadius: misc.borderRadius(),
            border: misc.borderStyle('grey.300'),
            boxShadow: 'none',
            '> .MuiList-root': {
              borderRadius: misc.borderRadius(),
              '> .MuiButtonBase-root:first-of-type': {
                borderTopLeftRadius: spacing(0.5),
                borderTopRightRadius: spacing(0.5),
              },
              '> .MuiButtonBase-root:last-of-type': {
                borderBottomLeftRadius: spacing(0.5),
                borderBottomRightRadius: spacing(0.5),
              },
            },
          },
        },
      },
    },
  }) satisfies ComponentCreation
